module.exports = __webpack_public_path__ + "static/media/fruit-icon-watermelon.aa1e0f58.jpg";